<div class="max-w-1xl mx-auto bg-white p-8 rounded-lg shadow-lg">
  <div class="flex flex-wrap pb-4 justify-start">
    <h1 class="headeradminui-text pl-2">Manage Email Templates</h1>
  </div>
  <div class="flex flex-row justify-end gap-3 pb-4">
    <button nz-button nzType="primary" [routerLink]="['/email-templates/add']">
      <span nz-icon nzType="plus" nzTheme="outline"></span>
      Create Email Templates
    </button>
  </div>
  <div class="flex flex-row justify-end mb-3">
    <div class="w-[40%]">
      <nz-input-group nzSearch nzSize="large" [nzAddOnAfter]="suffixButton">
        <input
          type="text"
          nz-input
          [(ngModel)]="globalSearchInput"
          placeholder="Search for title"
        />
      </nz-input-group>
    </div>
  </div>

  <ng-template #suffixButton>
    <button
      nz-button
      nzType="primary"
      nzSize="small"
      nzSearch
      (click)="searchGlobal()"
    >
      Search
    </button>
  </ng-template>
  <ng-template #tableHead>
    <div nz-row nzJustify="space-between">
      <div nz-col>
        <span class="font-bold">Email Templates</span>
      </div>
      <div class="flex gap-2">
        <nz-switch
          [(ngModel)]="isVisible"
          (ngModelChange)="onToggleVisibility()"
          nzCheckedChildren="Hide hidden items"
          nzUnCheckedChildren="Show hidden items"
        ></nz-switch>

        <div nz-col>
          <button
            class="btn-color"
            nz-button
            nzSize="small"
            nzType="primary"
            (click)="resetFilter()"
          >
            Clear filter
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <nz-spin [nzSpinning]="pageLoading" nzTip="Fetching Email Templates......">
    <nz-table
      #Table
      [nzTitle]="tableHead"
      [nzScroll]="{ y: '500px' }"
      class="mt-5"
      [nzData]="data"
      [nzShowPagination]="true"
      nzFrontPagination="false"
      [nzTotal]="totalCount"
      [nzPageSize]="pageSize"
      [nzBordered]="true"
      [nzShowSizeChanger]="true"
      [nzPageSizeOptions]="pageSizeOptions"
      [nzPageIndex]="pageNo"
      nzTableLayout="fixed"
      (nzPageIndexChange)="nzPageIndexChange($event)"
      (nzPageSizeChange)="nzPageSizeChange($event)"
    >
      <thead>
        <tr>
          <th>Title</th>
          <th>Subject</th>
          <th>
            Status
            <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="statusMenu">
              <span nz-icon nzType="filter"></span>
            </nz-filter-trigger>
          </th>
          <th>
            Tags
            <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="tagsMenu">
              <span nz-icon nzType="filter"></span>
            </nz-filter-trigger>
          </th>
          <th>Total Send</th>
          <th>Created At</th>
          <th nzWidth="25%">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of Table.data">
          <td>
            {{ data.title }}
          </td>
          <td>
            {{ data.subject }}
          </td>
          <td>
            <nz-tag
              class="mt-2 mb-2"
              [nzColor]="
                data.status === EmailTemplateStatus.DRAFT ? 'red' : 'green'
              "
              >{{ data.status }}</nz-tag
            >
          </td>
          <td>
            <nz-tag
              *ngFor="let data of data.tagsWithColor"
              class="mt-2 mb-2"
              [nzColor]="data.color"
              >{{ data.data }}</nz-tag
            >
          </td>
          <td (click)="navigateToLogs(data.id)">
            <span class="cursor-pointer">{{ data.totalSend }}</span>
          </td>
          <td>
            {{ utils.convertEpochToFormattedDate(data.createdAt) }}
          </td>
          <td nzRight>
            <div class="flex items-center justify-evenly">
              <span nz-tooltip nzTooltipTitle="View Email Templates">
                <button
                  [routerLink]="['/email-templates/view/' + data.id]"
                  nz-button
                  nzType="primary"
                  nzShape="circle"
                >
                  <span nz-icon nzType="eye" nzTheme="outline"></span>
                </button>
              </span>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </nz-spin>
</div>
<nz-dropdown-menu #tagsMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <div nz-col>
        <span class="font-bold">Tags</span>
        <nz-divider></nz-divider>
        <nz-checkbox-wrapper (nzOnChange)="tagFilter($event)">
          <div *ngFor="let tag of tagsCheckBoxOptions" nz-row>
            <div nz-col>
              <label
                nz-checkbox
                [nzValue]="tag.value"
                [ngModel]="tag.checked"
                >{{ tag.label }}</label
              >
            </div>
          </div>
        </nz-checkbox-wrapper>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="getData()">
          Ok
        </button>
      </div>

      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="resetFilter()">
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>
<nz-dropdown-menu #statusMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div nz-row>
      <div nz-col>
        <span class="font-bold">Status</span>
        <nz-divider></nz-divider>
        <nz-checkbox-wrapper (nzOnChange)="statusFilter($event)">
          <div *ngFor="let status of statusCheckBoxOptions" nz-row>
            <div nz-col>
              <label
                nz-checkbox
                [nzValue]="status.value"
                [ngModel]="status.checked"
                >{{ status.label }}</label
              >
            </div>
          </div>
        </nz-checkbox-wrapper>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="getData()">
          Ok
        </button>
      </div>

      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="resetFilter()">
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>
